// extracted by mini-css-extract-plugin
module.exports = {"content":"IntroTab_content_20kHv","headline":"IntroTab_headline_A24cE"};